import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-[#050505] border-t border-white/5">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          {/* Brand */}
          <div>
            <Link 
              to="/" 
              data-testid="footer-logo"
              className="text-white font-['Playfair_Display'] text-xl tracking-wider"
            >
              PARAGON
            </Link>
            <p className="mt-6 text-sm text-[#666] leading-relaxed max-w-xs">
              Performance without interference.<br />
              The quiet advantage.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="caption-text mb-6">Navigate</h4>
            <div className="flex flex-col gap-4">
              <Link to="/philosophy" data-testid="footer-philosophy" className="footer-link">Philosophy</Link>
              <Link to="/our-story" data-testid="footer-our-story" className="footer-link">Our Story</Link>
              <Link to="/the-work" data-testid="footer-the-work" className="footer-link">The Work</Link>
              <Link to="/the-stable" data-testid="footer-the-stable" className="footer-link">Our Clients</Link>
              <Link to="/apply" data-testid="footer-apply" className="footer-link">Contact</Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="caption-text mb-6">Contact</h4>
            <p className="text-sm text-[#666] leading-relaxed">
              Paragon operates primarily through<br />
              invitation and referral.
            </p>
            <Link 
              to="/apply" 
              data-testid="footer-begin-conversation"
              className="inline-block mt-6 text-white/60 hover:text-white text-xs tracking-widest uppercase transition-colors"
            >
              Begin the Conversation →
            </Link>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-[#444]">
            © {new Date().getFullYear()} Paragon. All rights reserved.
          </p>
          <p className="text-xs text-[#444]">
            Performance Upstream.
          </p>
        </div>
        
        {/* Copyright */}
        <div className="mt-8 text-center">
          <p className="text-[10px] text-[#333]">
            Copyright 2026 Clear State Holdings Limited
          </p>
        </div>
      </div>
    </footer>
  );
};
